import React from 'react';
import { useState, useEffect } from 'react';
import { HashRouter, Routes, Route } from "react-router-dom";

import { Header } from "./page/Header.jsx";
import { MyDeck } from './page/MyDeck/MyDeck.jsx';
import { DeckBuilder } from "./page/DeckBuilder/DeckBuilder.jsx";
import { CardSearch } from "./page/CardSearch/CardSearch.jsx";
import { SearchSetting } from './page/SearchSetting/SearchSetting.jsx';
import { OptionPage } from './page/Option/OptionPage.jsx';
import { AccountPage } from './page/Account/AccountPage.jsx';

import { useTranslation } from "react-i18next";
import { MyModal, MyYesNoDialog } from './component/ui/UI.jsx';
import { useAuth } from './context/AuthContext.jsx';
import { useFirestore } from "./context/FirestoreContext.jsx";
import { useSave } from './context/SaveContext.jsx';
import { useApp } from './context/AppContext.jsx';
import { ROUTE } from "./page/Route.jsx";

export const App = () =>
{
	const [headerHeight, setHeaderHeight] = useState(56);
	let START_PATH = "/cardset";
	//START_PATH = "/mydeck";

	const { t } = useTranslation();
	const {yesNoModal, running: appRuning} = useApp();
	const {user, running: authRunning} = useAuth();
	const {running: saveRunning} = useFirestore();
	const running = appRuning || authRunning || saveRunning;
	const {loadDeckList} = useSave();

	useEffect(() => {
		if (user) {
			loadDeckList();
		}
	}, [user]);

	//onst Router = isDev ? HashRouter : BrowserRouter;

	return(
		<div>
			<div className="overflow-y-hidden vh-100">
				<Header setHeaderHeight={setHeaderHeight} />
				<div
					className="h-100"
					style={{paddingTop: `${headerHeight}px`}}
				>
					<Routes>
						<Route path={ROUTE.HOME} element={<OptionPage />} />
						<Route path={ROUTE.MYDECK} element={<MyDeck />} />
						<Route path={ROUTE.DECKBUILDER} element={<DeckBuilder />} />
						<Route path={ROUTE.CARDSEARCH} element={<CardSearch /> }/>
						<Route path={ROUTE.SEARCHSETTING} element={<SearchSetting /> }/>
						<Route path={ROUTE.OPTION} element={<OptionPage /> }/>
						<Route path={ROUTE.ACCOUNT} element={<AccountPage /> }/>
						{/*<Route path={ROUTE.HOME} element={<Navigate to={ROUTE.MYDECK} replace />} />*/}
					</Routes>
				</div>
			</div>
			{running && <MyModal />}
			{yesNoModal && <MyYesNoDialog
				title={yesNoModal.title ?? t("Common_Attention")}
				body={yesNoModal.body}
				onClose={yesNoModal.onClose}
				onSubmit={yesNoModal.onSubmit}
				onCancel={yesNoModal.onCancel}
				yes={yesNoModal.yes ?? t("Common_Yes")}
				no={yesNoModal.no ?? t("Common_No")}
				hideNo={yesNoModal.hideNo}
			/>}
		</div>
	);
};
